// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"LinkButton_linkButton__5Ck8q"};